import { useEffect, useState } from "react";
import BookManager from "../../../services/home/BookManager";
import { Loader2 } from "lucide-react";
import BookGrid from "../../../components/home/exploreBooksComponents/BookGrid";

const BooksByAuthor = ({ authorId, userId = null }) => {
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [view, setView] = useState('grid');

  useEffect(() => {
    const fetchBooks = async () => {
      try {
        const response = await BookManager.getBooksByAuthor(authorId);
        setBooks(response || []);
      } catch (error) {
        console.error("Failed to fetch books:", error);
      } finally {
        setLoading(false);
      }
    };

    if (authorId) {
      fetchBooks();
    }
  }, [authorId, userId]);

  if (loading) {
    return (
      <div className="flex justify-center items-center p-6">
        <Loader2 className="animate-spin w-8 h-8 text-primary" />
      </div>
    );
  }

  if (!books.length) {
    return (
      <div className="text-center text-gray-500 p-6">
        No books found for this author.
      </div>
    );
  }

  // Map books data to match the BookGrid structure
  const mappedBooks = books.map(b => ({
    id: b.bookId || b.id,
    title: b.bookName || b.title,
    author: b.author?.authorName || b.author,
    isbn: b.bookIsbn13 || b.isbn,
    description: b.bookDescription || " ",
    rating: Math.round(b.rating || 0),
    image: Array.isArray(b.bookImages) ? b.bookImages[0] : b.image,
  }));

  return (
    <div className="p-4">
      <h2 className="text-2xl font-semibold mb-4 text-primary">Available Books by Author</h2>

      <BookGrid
        books={mappedBooks}
        view={view}
        onViewChange={setView}
        loading={loading}
      />
    </div>
  );
};

export default BooksByAuthor;
